import Vue from 'vue'
import VueRouter from 'vue-router'
// import Home from '../views/Home.vue'

Vue.use(VueRouter)

const routes = [
  {
    path: '/',
    redirect: '/home',
  },
  {
    path: '/home',
    name: 'Home',
    component: () => import('@/views/Home.vue'),
    meta: { requiresAuth: true }
  },
  {
    path: '/record',
    name: 'Record',
    component: () => import('@/views/Record.vue')
  },
  {
    path: '/edit',
    name: 'Edit',
    component: () => import('@/views/Edit.vue')
  },
  {
    path: '/points',
    name: 'Points',
    component: () => import('@/views/Points.vue')
  },
  {
    path: '/points-info',
    name: 'PointsInfo',
    component: () => import('@/views/PointsInfo.vue')
  },
  {
    path: '/exchange-log',
    name: 'ExchangeLog',
    component: () => import('@/views/ExchangeLog.vue')
  },
  // {
  //   path: '/about',
  //   name: 'About',
  //   component: () => import('@/views/About.vue')
  // }
]

const router = new VueRouter({
  mode: 'hash',
  base: process.env.BASE_URL,
  routes,
  scrollBehavior (to, from, savedPosition) {
    return { x: 0, y: 0 }
  },
})

export default router
